"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"

const navItems = [
  { href: "/student/home",     icon: "🏠", label: "首頁" },
  { href: "/student/homework", icon: "📋", label: "作業" },
  { href: "/student/pet",      icon: "🐾", label: "寵物" },
  { href: "/student/shop",     icon: "🛒", label: "商店" },
  { href: "/student/profile",  icon: "👤", label: "我的" },
]

export default function BottomNav() {
  const pathname = usePathname()

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-surface border-t border-border/60 safe-b">
      <div className="flex items-center justify-around px-2 py-2 max-w-2xl mx-auto">
        {navItems.map((item) => {
          const active = pathname.startsWith(item.href)
          return (
            <Link
              key={item.href}
              href={item.href}
              className={`flex flex-col items-center gap-0.5 px-4 py-2 rounded-2xl transition-all duration-200 min-w-[60px] ${
                active
                  ? "text-primary bg-primary/10"
                  : "text-text-muted hover:text-text"
              }`}
            >
              <span className="text-2xl leading-none">{item.icon}</span>
              <span className={`text-xs font-medium ${active ? "text-primary" : ""}`}>
                {item.label}
              </span>
            </Link>
          )
        })}
      </div>
    </nav>
  )
}
